import {requiredValidation, urlsValidation} from "../Validation";

export const required = requiredValidation();
export const urls = urlsValidation();